import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { initializeBackendRuntime, disposeBackendRuntime } from './store/bootstrap';
import configureStore from './store/Store';
import { App, ModalApp, LaunchScreen } from './containers/containers';
import { IS_ELECTRON_APP, IS_UI_ONLY_MODE } from './config/electron';
import { isAppPaused } from './utils/appPause';
import { initializeStartupLoadingTimeout } from './store/startup';

const { store, persistor } = configureStore();
initializeStartupLoadingTimeout();

if (isAppPaused()) {
    ReactDOM.render(
        <PersistGate persistor={persistor}>
            <Provider store={store}>
                <LaunchScreen />
            </Provider>
        </PersistGate>,
        document.getElementById('main')
    );
} else if (IS_UI_ONLY_MODE && !IS_ELECTRON_APP && window.name !== 'targetWindow') {
    ReactDOM.render(
        <PersistGate persistor={persistor}>
            <Provider store={store}>
                <ModalApp />
            </Provider>
        </PersistGate>,
        document.getElementById('main')
    );
} else {
    initializeBackendRuntime(store);
    window.addEventListener('beforeunload', () => disposeBackendRuntime(), { once: true });

    ReactDOM.render(
        <PersistGate persistor={persistor}>
            <Provider store={store}>
                <App />
            </Provider>
        </PersistGate>,
        document.getElementById('main')
    );
}
